import styled from 'styled-components';
import {Badge} from './GenericBadges';
import {badgeColors} from './badgeColors';

export const CampaignSaleBadge = styled(Badge)<{backgroundColor?: string}>`
  color: ${badgeColors.colors.sale};
  background-color: ${({backgroundColor}) =>
    backgroundColor || badgeColors.backgroundColors.campaign};
`;
